var c = function(e) {
  return e instanceof SVGElement && "getBBox" in e;
}, f = function(e) {
  if (c(e)) {
    var n = e.getBBox(), t = n.width, s = n.height;
    return !t && !s;
  }
  var i = e, r = i.offsetWidth, a = i.offsetHeight;
  return !(r || a || e.getClientRects().length);
}, o = function(e) {
  var n;
  if (e instanceof Element)
    return !0;
  var t = (n = e == null ? void 0 : e.ownerDocument) === null || n === void 0 ? void 0 : n.defaultView;
  return !!(t && e instanceof t.Element);
}, u = function(e) {
  switch (e.tagName) {
    case "INPUT":
      if (e.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
};
export {
  o as isElement,
  f as isHidden,
  u as isReplacedElement,
  c as isSVG
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/utils/element.js
// module id = 289
// module chunks = 41